import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ESPORTS, LANGUAGES } from '../../../constants/defaultValues';
import Sport from '../../shared/SportIcons/Sport';
import { generateEventsUrl } from '../../../utils/helpers';
import classnames from 'classnames';
import styles from './SportsNav.module.scss';
import Slider from 'react-slick';

const NavItems = ({ onMouseDown, onSportClick, sliderSettings }) => {
    const locale = useSelector(state => state.settings.locale);
    const favoriteEvents = useSelector(state => state.favorites.events);
    const { sportsList } = useSelector(state => state.sportTypes);
    const { isLive, isESports, sportRefId } = useSelector(state => state.sportEvents);

    const filteredSportsList = useMemo(() => {
        if (!sportsList.length) return [];

        const favoriteId = '0:bt:sport:1';
        let favorite;
        const list = [];

        sportsList.forEach(sport => {
            if (sport.referenceId === favoriteId) {
                favorite = sport;
            } else {
                list.push(sport);
            }
        });

        return [favorite, ...list].filter(sport => !!sport);
    }, [sportsList]);

    const renderSportsList = sports =>
        sports.map(sport => {
            const isFavorites = sport.referenceId === '0:bt:sport:1';
            const referenceId = isFavorites ? 'favorites' : sport.referenceId;
            const eventCount = isFavorites
                ? favoriteEvents.filter(fvrt => isLive === fvrt.live).length
                : sport.eventCount;
            const isActive = sportRefId === referenceId;

            return (
                <div key={sport.id}>
                    <NavLink
                        className={classnames(styles.navLink, {
                            [styles.active]: isActive,
                        })}
                        to={{
                            pathname: generateEventsUrl({
                                isLive,
                                isESports,
                                sportId: encodeURIComponent(referenceId),
                            }),
                            sportProps: {
                                sportName: sport.names[locale] || sport.names[LANGUAGES.eng],
                                eventCount,
                            },
                        }}
                        onMouseDown={onMouseDown}
                        onClick={onSportClick}
                    >
                        <Sport sportId={referenceId} isActive={isActive} className={styles.icon} />
                        <span className={styles.title}>
                            {sport.names[locale] || sport.names[LANGUAGES.eng]}
                        </span>
                        <span className={styles.count}>{`(${eventCount})`}</span>
                    </NavLink>
                </div>
            );
        });

    return isLive ? (
        <Slider {...sliderSettings}>{renderSportsList(filteredSportsList)}</Slider>
    ) : (
        renderSportsList(filteredSportsList)
    );
};

export default NavItems;
